import { render, staticRenderFns } from "./PWAPrompt.vue?vue&type=template&id=1f7b50dc&"
import script from "./PWAPrompt.vue?vue&type=script&lang=js&"
export * from "./PWAPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports